import { IFormProps } from "./IFormProps";
import { makeWidget, registerRenderer } from "./registry";

export const getRendererOption = (
  schema: any,
  name: string,
  defaultValue: any,
) =>
  (schema &&
    schema.form &&
    schema.form.rendererOptions &&
    schema.form.rendererOptions[name]) ||
  defaultValue;


export const renderFieldAsRow = (formikParams: any) => (config: any) =>
(
  <div>
    {config.onRenderFieldHeader?.(formikParams, config)}
    {config.label && config.type !== "boolean" && <label className="form-label" htmlFor={config.key}>
      {config.label}
      {config.required && <span className="text-danger" style={{ marginLeft: "2px" }}>*</span>}
    </label>}
    {
      config.helpText !== undefined &&
        typeof config.helpText === "function" ? (
        config.helpText({
          ...formikParams,
          ...config,
        })
      ) : (
        <div className="form-text">{config.helpText}</div>
      )
    }
    {makeWidget(config, formikParams)}
    {config.label && config.type === "boolean" && <label style={{ marginLeft: "6px", maxWidth: "90%" }} className="form-label" htmlFor={config.key}>
      {config.label}
      {config.required && <span className="text-danger" style={{ marginLeft: "2px" }}>*</span>}
    </label>}
    {formikParams.errors[config.name] && typeof formikParams.errors[config.name] === "string" && (formikParams.submitCount > 0 || formikParams.touched[config.name]) && <div><span className="text-danger">{formikParams.errors[config.name]}</span></div>}
    {config.onRenderFieldFooter?.(formikParams, config)}
  </div >
);

registerRenderer("stack", (props: IFormProps) => (formikParams: any) => (
  <form onSubmit={formikParams.handleSubmit}>
    {props.schema.form.onRenderLayoutHeader?.({
      ...props,
      ...formikParams
    })}
    {props.schema.fields
      .filter((x) => props.schema.predicate?.(formikParams, x) ?? true)
      .map((x, i) => (
        <div key={i.toString()}>{renderFieldAsRow(formikParams)(x)}</div>
      ))}
    {props.schema.form.onRenderLayoutFooter?.({
      ...props,
      ...formikParams
    })}
  </form>
));


registerRenderer("grouped", (props: IFormProps) => (formikParams: any) => {
  const fields = props.schema.fields.reduce(function (r, a) {
    r[a.group] = r[a.group] || [];
    r[a.group].push(a);
    return r;
  }, Object.create(null));
  return (
    <form onSubmit={formikParams.handleSubmit}>
      {props.schema.form.onRenderLayoutHeader?.({
        ...props,
        ...formikParams
      })}
      <div></div>
      {
        Object.keys(fields).map(f => <>
          <fieldset key={f}>
            <legend>{f}</legend>
            <div key={f} className="col-lg-12" style={{ padding: "15px", position: "relative" }}>
              <div className="row">
                {
                  fields[f]
                    .filter((x: any) => props.schema.predicate?.(formikParams, x) ?? true)
                    .map((x: any, i: number) => (
                      <div className={x.gridClassName ?? "col-lg-12"} key={i.toString()}>{renderFieldAsRow(formikParams)(x)}</div>
                    ))
                }</div>
            </div>
          </fieldset>
        </>)}
      {props.schema.form.onRenderLayoutFooter?.({
        ...props,
        ...formikParams
      })}
    </form>
  )
});
